import MultipleSelectedOptionTemplate from './MultipleSelectedOption';

export default MultipleSelectedOptionTemplate;
